import React, { useState } from 'react';
import { MapPin, Phone, Mail, MessageCircle, Clock, Send } from 'lucide-react';
import { mockData } from '../mock/data';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    properties: '1',
    service: 'express',
    message: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission - will be replaced with actual backend call
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        name: '',
        phone: '',
        email: '',
        properties: '1',
        service: 'express',
        message: ''
      });
    }, 3000);
  };

  const contactInfo = [
    {
      icon: Phone,
      title: "Téléphone",
      value: mockData.contact.phone,
      link: `tel:${mockData.contact.phone}`
    },
    {
      icon: MessageCircle,
      title: "WhatsApp",
      value: "Message Direct",
      link: mockData.contact.whatsappLink
    },
    {
      icon: Mail,
      title: "Email",
      value: "contact@neonkawa.ma",
      link: "mailto:contact@neonkawa.ma"
    },
    {
      icon: MapPin,
      title: "Localisation",
      value: mockData.contact.location,
      link: null
    }
  ];

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1>Contactez-Nous</h1>
          <p>Réponse garantie en moins de 15 minutes pendant les heures d'ouverture</p>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="contact-info-section">
        <div className="section-container">
          <div className="contact-info-grid">
            {contactInfo.map((info, index) => {
              const IconComponent = info.icon;
              return (
                <div key={index} className="contact-info-card">
                  <div className="contact-icon">
                    <IconComponent size={32} />
                  </div>
                  <h3>{info.title}</h3>
                  {info.link ? (
                    <a href={info.link} target="_blank" rel="noopener noreferrer" className="contact-value">
                      {info.value}
                    </a>
                  ) : (
                    <p className="contact-value">{info.value}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section className="contact-form-section">
        <div className="section-container">
          <div className="contact-layout">
            <div className="contact-form-wrapper">
              <h2>Demander un Devis</h2>
              <p className="form-subtitle">Remplissez le formulaire et nous vous recontactons dans les 15 minutes</p>
              
              {isSubmitted ? (
                <div className="success-message">
                  <div className="success-icon">✓</div>
                  <h3>Message Envoyé!</h3>
                  <p>Nous vous recontactons très bientôt sur WhatsApp ou par téléphone.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-group">
                    <label htmlFor="name">Nom Complet *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Mohammed Ali"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">Numéro WhatsApp *</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="+212 6XX XXX XXX"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="votre@email.com"
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="properties">Nombre de Propriétés</label>
                      <select
                        id="properties"
                        name="properties"
                        value={formData.properties}
                        onChange={handleChange}
                      >
                        <option value="1">1 propriété</option>
                        <option value="2">2 propriétés</option>
                        <option value="3">3 propriétés</option>
                        <option value="4+">4+ propriétés</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="service">Service Souhaité</label>
                      <select
                        id="service"
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                      >
                        <option value="express">Nettoyage Express</option>
                        <option value="abonnement">Abonnement Mensuel</option>
                        <option value="urgence">Service Urgence</option>
                        <option value="profond">Nettoyage Profond</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="4"
                      placeholder="Dites-nous en plus sur vos besoins..."
                    ></textarea>
                  </div>

                  <button type="submit" className="gradient-btn submit-btn">
                    <Send size={20} />
                    <span>Envoyer la Demande</span>
                  </button>
                </form>
              )}
            </div>

            <div className="contact-sidebar">
              <div className="sidebar-card">
                <h3>Horaires d'Ouverture</h3>
                <div className="hours-list">
                  <div className="hours-item">
                    <Clock size={18} />
                    <div>
                      <p className="day">Lundi - Samedi</p>
                      <p className="time">8h00 - 20h00</p>
                    </div>
                  </div>
                  <div className="hours-item">
                    <Clock size={18} />
                    <div>
                      <p className="day">Dimanche</p>
                      <p className="time">9h00 - 18h00</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="sidebar-card highlight">
                <MessageCircle size={32} />
                <h3>Besoin d'une Réponse Immédiate?</h3>
                <p>Contactez-nous directement sur WhatsApp</p>
                <a href={mockData.contact.whatsappLink} target="_blank" rel="noopener noreferrer" className="gradient-btn">
                  Ouvrir WhatsApp
                </a>
              </div>

              <div className="sidebar-card">
                <h3>Intervention Urgence</h3>
                <p>Besoin d'un nettoyage en moins de 4h?</p>
                <a href={`tel:${mockData.contact.phone}`} className="outline-btn">
                  Appeler Maintenant
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;